import React, { Component } from "react";
import "./Skills.css";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import { skills } from "../../portfolio";
import DesignImg from "./DesignImg";

function GetSkillSvg(props) {
  if (props.fileName === "cv")
    return (
      <svg
        height="400"
        viewBox="0 0 64 64"
        width="400"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Ai-eye-vision-processeor-technology-artificial_intelligence"
          data-name="Ai-eye-vision-processeor-technology-artificial intelligence"
        >
          <title>CV by Payungkead</title>
          <path
            d="m61 32s-12.984 15-29 15-29-15-29-15 12.984-15 29-15 29 15 29 15z"
            fill="#5bcbfa"
          />
          <circle cx="32" cy="32" fill="#ff9811" r="15" />
          <g fill="#f6cc4f">
            <circle cx="8" cy="49" r="3" />
            <circle cx="23" cy="56" r="3" />
            <circle cx="40" cy="58" r="3" />
            <circle cx="58" cy="49" r="3" />
            <path d="m54 3a3 3 0 1 1 -3 3 3 3 0 0 1 3-3z" />
            <circle cx="32" cy="6" r="3" />
            <path d="m14 6a3 3 0 1 1 -3-3 2.985 2.985 0 0 1 3 3z" />
          </g>
          <path d="m23 23h18v18h-18z" fill="#ec455a" />
          <path d="m37 27v10h-10v-7.04l3.01-2.96z" fill="#f09898" />
          <path d="m26 29.959v7.041a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0 -1-1h-6.992a1 1 0 0 0 -.7.287l-3.008 2.959a1 1 0 0 0 -.3.713zm2 .419 2.417-2.378h5.583v8h-8z" />
          <path d="m58 45a4 4 0 0 0 -3.858 3h-2.142v-6.9a54.028 54.028 0 0 0 9.756-8.445 1 1 0 0 0 0-1.308 54.23 54.23 0 0 0 -13.756-10.888v-8.944l3.445-2.463a3.962 3.962 0 0 0 2.555.948 4.036 4.036 0 1 0 -3.725-2.571l-3.857 2.758a1 1 0 0 0 -.418.813v8.429a32.984 32.984 0 0 0 -13-3.4v-6.171a4 4 0 1 0 -2 0v6.17a32.409 32.409 0 0 0 -12 2.942v-7.97a1 1 0 0 0 -.418-.813l-3.857-2.758a3.993 3.993 0 1 0 -3.725 2.571 3.962 3.962 0 0 0 2.555-.948l3.445 2.463v8.414a53.947 53.947 0 0 0 -14.756 11.417 1 1 0 0 0 0 1.308 54.471 54.471 0 0 0 11.756 9.732v5.614h-2.142a4 4 0 1 0 0 2h3.142a1 1 0 0 0 1-1v-5.459a35.371 35.371 0 0 0 13 4.3v7.159h-2.142a4 4 0 1 0 0 2h3.142a1 1 0 0 0 1-1v-8.028c.333.012.664.028 1 .028a29.067 29.067 0 0 0 7-.885v7.027a4 4 0 1 0 2 0v-7.588a41.043 41.043 0 0 0 9-4.168v6.614a1 1 0 0 0 1 1h3.142a3.993 3.993 0 1 0 3.858-5zm-4-41a2 2 0 1 1 -2 2 2 2 0 0 1 2-2zm-43 4a2 2 0 1 1 2-2 2 2 0 0 1 -2 2zm-3 43a2 2 0 1 1 2-2 2 2 0 0 1 -2 2zm15 7a2 2 0 1 1 2-2 2 2 0 0 1 -2 2zm19 0a2 2 0 1 1 -2-2 2 2 0 0 1 2 2zm17.641-26c-1.939 2.042-8.373 8.349-16.828 11.758a15.922 15.922 0 0 0 .008-23.51c8.445 3.411 14.879 9.713 16.82 11.752zm-26.641-10v-3.949a13.834 13.834 0 0 1 3 .539v3.41zm-5 0v-3.41a13.834 13.834 0 0 1 3-.539v3.949zm12 2v16h-16v-16zm-9 18v3.949a13.834 13.834 0 0 1 -3-.539v-3.41zm2 0h3v3.41a13.834 13.834 0 0 1 -3 .539zm5 0h3a1 1 0 0 0 1-1v-3h2.63a14.071 14.071 0 0 1 -6.63 6.63zm7.41-6h-3.41v-3h3.949a13.9 13.9 0 0 1 -.539 3zm-3.41-5v-3h3.41a13.9 13.9 0 0 1 .539 3zm0-5v-3a1 1 0 0 0 -1-1h-3v-2.63a14.071 14.071 0 0 1 6.63 6.63zm-16-6.63v2.63h-3a1 1 0 0 0 -1 1v3h-2.63a14.071 14.071 0 0 1 6.63-6.63zm-7.41 8.63h3.41v3h-3.949a13.9 13.9 0 0 1 .539-3zm3.41 5v3h-3.41a13.9 13.9 0 0 1 -.539-3zm0 5v3a1 1 0 0 0 1 1h3v2.63a14.071 14.071 0 0 1 -6.63-6.63zm8-32a2 2 0 1 1 2 2 2 2 0 0 1 -2-2zm-25.641 26c1.939-2.042 8.373-8.349 16.828-11.758a15.922 15.922 0 0 0 -.008 23.51c-8.445-3.411-14.879-9.713-16.82-11.752zm53.641 19a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z" />
          <circle cx="26" cy="26" r="1" />
        </g>
      </svg>
    );
  else if (props.fileName === "cg_scivis")
    return (
      <img
        src={require(`../../assests/images/cg_img.png`)}
        width="400"
        height="400"
        alt=""
      />
    );
  // fallback image
  return <DesignImg theme={props.theme} />;
}

class SkillSection extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div>
        {skills.data.map((skill) => {
          return (
            <div className="skills-main-div" key={skill.title}>
              <div className="skills-image-div">
                <GetSkillSvg fileName={skill.fileName} theme={theme} />
              </div>

              <div className="skills-text-div">
                <h1 className="skills-heading" style={{ color: theme.text }}>
                  {skill.title}
                </h1>
                <SoftwareSkill logos={skill.softwareSkills} />
                <div>
                  {skill.skills.map((skillSentence) => {
                    return (
                      <p
                        className="subTitle skills-text"
                        style={{ color: theme.secondaryText }}
                        key={skillSentence}
                      >
                        {skillSentence}
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default SkillSection;
